// 環境チェック用のユーティリティ関数

/**
 * 開発環境かどうかを判定
 */
export const isDev = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * プロダクション環境かどうかを判定
 */
export const isProd = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

/**
 * テスト環境かどうかを判定
 */
export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};

/**
 * 現在の環境名を取得
 */
export const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};

// === 機能フラグ ===
// 開発中の機能を環境やフラグでゲートする。本番ローンチ時は実装を `true` に固定するか、
// 参照箇所（grep でこの関数名を検索）ごと削除して掃除する。

/**
 * ライブラリのフォルダ機能
 */
export const isFolderFeatureEnabled = (): boolean => true;